import script from "./MTB_Slide_VariantData.vue?vue&type=script&setup=true&lang=js"
export * from "./MTB_Slide_VariantData.vue?vue&type=script&setup=true&lang=js"

import "./MTB_Slide_VariantData.vue?vue&type=style&index=0&id=23218a62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23218a62"]])

export default __exports__